<template>
  <v-dialog
    v-model="visible"
    @keydown.esc="close"
    persistent
    scrollable
    max-width="720"
    style="z-index: 6"
  >
    <v-form ref="addNormForm" @submit.prevent="submit">
      <v-card class="glass-card-modal">
        <!-- Glass Header -->
        <div class="glass-header-modal">
          <v-row class="align-center ma-0 pa-0">
            <v-col cols="auto" class="pa-0">
              <v-icon color="white" size="32" class="mr-3">mdi-file-document-outline</v-icon>
            </v-col>
            <v-col class="pa-0">
              <h2 class="modal-title">Uredi Normativ</h2>
              <p class="modal-subtitle">Dodaj ili uredi sastojke artikla</p>
            </v-col>
            <v-col cols="auto" class="pa-0">
              <v-icon color="white" size="28" @click="close" class="close-icon">mdi-close</v-icon>
            </v-col>
          </v-row>
        </div>
        <v-card-text class="modal-content">
          <v-container fluid class="pa-4">
            <!-- Add Norm Section -->
            <v-row dense class="align-center mb-4">
              <v-col cols="12" sm="8">
                <v-autocomplete
                  v-model="normItemSelected"
                  :items="items"
                  item-text="name"
                  return-object
                  label="Odaberi artikl za dodati"
                  dense
                  outlined
                  hide-details
                  class="filter-select"
                >
                  <template #prepend-inner>
                    <v-icon color="#3989C9" small>mdi-package-variant</v-icon>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="4">
                <v-btn
                  class="add-norm-btn"
                  @click="addNorm"
                  @keyup.enter="addNorm"
                  elevation="0"
                  block
                >
                  <v-icon small class="mr-1">mdi-plus</v-icon>
                  Dodaj
                </v-btn>
              </v-col>
            </v-row>
            <!-- Norms List -->
            <v-row v-if="norms.length > 0" dense>
              <v-col cols="12">
                <div class="norms-list-header mb-2">
                  <h3 class="list-title">Dodani sastojci</h3>
                </div>
                <div class="norms-list">
                  <v-card
                    v-for="(item, nkey) in norms"
                    :key="nkey"
                    class="norm-item-card mb-3"
                    elevation="0"
                  >
                    <v-row dense class="align-center">
                      <v-col cols="12" sm="6">
                        <v-text-field
                          :value="item.item.name"
                          label="Sastojak"
                          dense
                          outlined
                          hide-details
                          readonly
                          class="filter-select"
                        >
                          <template #prepend-inner>
                            <v-icon color="#3989C9" small>mdi-food</v-icon>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="8" sm="4">
                        <v-text-field
                          v-model="item.quantity"
                          label="Količina"
                          dense
                          outlined
                          hide-details
                          class="filter-select"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="4" sm="2" class="text-right">
                        <v-btn
                          class="remove-norm-btn"
                          @click="removeNorm(item)"
                          icon
                          small
                        >
                          <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card>
                </div>
              </v-col>
            </v-row>

            <!-- Norm Type Selection - Hidden, always uses ON_SALE -->
            <!-- <v-row dense class="mt-2">
              <v-col cols="12">
                <v-radio-group v-model="selectedNormType" class="mt-0" hide-details>
                  <v-radio
                    v-for="normType in normTypes"
                    :key="normType.value"
                    :value="normType.value"
                    :label="normType.name"
                    color="#3989C9"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row> -->
          </v-container>
        </v-card-text>

        <v-card-actions class="modal-actions">
          <v-btn
            class="save-btn"
            type="submit"
            :loading="submitting"
            :disabled="submitting"
            elevation="0"
          >
            <v-icon small class="mr-2">mdi-content-save</v-icon>
            Spremi Normativ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import { df } from '@/plugins/firebase'
import state from '@/state'
import rules from '@/plugins/rules'
import { clone } from '@/plugins/utils'
export default {
  name: 'AddCategory',
  inject: ['showMsgBox', 'showLoader', 'hideLoader'],
  data: () => ({
    visible: false,
    name: undefined,
    submitting: false,
    picture: '',
    pictureDirty: false,
    rules: {
      req: rules.req('Required field')
    },
    items: [],
    currentItem: {},
    normItemSelected: undefined,
    norms: [],
    selectedNormType: 'ON_SALE'
  }),
  computed: {
    normTypes () {
      return [
        { name: 'Skini sastojke prilikom prodaje', value: 'ON_SALE' }
        // { name: 'Skini sastojke prilikom kreiranja artikla', value: 'ON_CREATE' }
      ]
    }
  },
  methods: {
    removeNorm (rmItem) {
      this.norms = this.norms.filter(norm => {
        if (norm.item.id !== rmItem.item.id) {
          return norm
        }
      })
    },
    addNorm () {
      if (!this.normItemSelected) { return }
      let found = false
      if (this.norms.length > 0) {
        this.norms.forEach(norm => {
          if (norm.item.id === this.normItemSelected.id) {
            found = true
          }
        })
      }

      if (!found) {
        const newNorm = {
          item: this.normItemSelected,
          quantity: 0,
          itemId: this.normItemSelected.id
        }

        if (this.normItemSelected.id.includes('.')) {
          newNorm.customUnitId = this.normItemSelected.id.split('.')[1]
          newNorm.itemId = this.normItemSelected.id.split('.')[0]
        }

        // Add new norm at the beginning of the array
        this.norms.unshift(newNorm)
        console.log('[AddNorm] Added norm:', newNorm.item.name, '- Total norms:', this.norms.length)
        console.log('[AddNorm] First norm in list:', this.norms[0].item.name)
      }
      this.normItemSelected = ''
    },
    async getCompItems () {

    },
    async open (currentItem, allItems, existing = undefined) {
      const items = []

      this.currentItem = currentItem
      const query = await df
        .collection(`companies/${state.getCurrentCompany().id}/items`)
        .where('status', '==', 'OK')

      query.get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            const item = doc.data()

            if (item.warehouse_units !== undefined && item.warehouse_units.units !== undefined) {
              Object.keys(item.warehouse_units.units).forEach(key => {
                const newItem = clone(item)
                newItem.name = item.warehouse_units.units[key].storage_unit
                newItem.prices = item.warehouse_units.units[key].prices
                // if (item.warehouse_units.units[key].storage_unit && item.warehouse_units.units[key].storage_unit !== '') {
                //   newItem.name = item.warehouse_units.units[key].storage_unit
                // } else {
                //   newItem.name = item.name
                // }

                var stUnit = item.warehouse_units.units[key].storage_unit
                if (stUnit === '.kom') {
                  stUnit = ''
                }

                newItem.name = item.name + ' ' + stUnit
                newItem.id = item.id + '.' + item.warehouse_units.units[key].id

                if (this.currentItem && this.currentItem.id !== newItem.id) {
                  items.push(newItem)
                } else if (!this.currentItem) {
                  items.push(newItem)
                }
              })
            } else {
              if (this.currentItem && this.currentItem.id !== item.id) {
                items.push(item)
              } else if (!this.currentItem) {
                items.push(item)
              }
            }
          })
          this.items = clone(items.sort((a, b) => a.name.localeCompare(b.name)))
        })

      this.visible = true
      // Zakomentirano jer je stavljeno da se ponovno dohvati sve prilikom otvaranja, ako ne bude trebalo do 30.05 obrisi
      // allItems.forEach(item => {
      //   if (item.warehouse_units !== undefined && item.warehouse_units.units !== undefined) {
      //     Object.keys(item.warehouse_units.units).forEach(key => {
      //       const newItem = clone(item)
      //       newItem.name = item.warehouse_units.units[key].storage_unit
      //       newItem.prices = item.warehouse_units.units[key].prices
      //       newItem.name = item.name + ' ' + item.warehouse_units.units[key].storage_unit
      //       newItem.id = item.id + '.' + item.warehouse_units.units[key].id

      //       this.items.push(newItem)
      //     })
      //   } else {
      //     this.items.push(item)
      //   }
      // })

      if (existing !== undefined && existing.length > 0) {
        existing.forEach(comp => {
          comp.item.name = comp.item.name ? comp.item.name : ''

          // Hack za razlike u imenovanju
          if (comp.item.name === '') {
            comp.item.name = comp.item.item_name ? comp.item.item_name : ''
          }

          comp.item.id = comp.item.id ? comp.item.id : ''

          if (comp.item.id === '') {
            comp.item.id = comp.item.item_id ? comp.item.item_id : ''
          }

          const newNorm = {
            item: comp.item,
            quantity: comp.quantity.toString().replace('.', ','),
            itemId: comp.item.id
          }

          if (comp.item.custom_unit === true) {
            newNorm.customUnitId = comp.item.custom_unit_id
            newNorm.itemId = comp.item.item_id
          }

          if (comp.customUnitId && comp.customUnitId !== '') {
            newNorm.customUnitId = comp.customUnitId
            newNorm.itemId = comp.itemId
          }

          this.norms.push(newNorm)
        })
      }
    },
    close () {
      this.$emit('close')
      this.visible = false
      this.norms = []
      this.normItemSelected = undefined
    },
    submit () {
      const that = this

      if (this.norms.some(norm => norm.quantity === '' || parseFloat(norm.quantity.replace(',', '.')) === 0)) {
        this.showMsgBox({ text: 'Količina ne smije biti 0.', actions: ['cancel'], cancelBtnText: 'OK', color: 'error' })
        return
      }

      if (!this.$refs.addNormForm.validate()) return

      // if (this.norms && this.norms.length > 0) {
      //   this.norms.forEach((norm, key) => {
      //     console.log('norm, key', norm, key)
      //     if (norm.customUnitId && norm.customUnitId !== '') {
      //       norm.quantity = parseFloat(norm.quantity) * norm.item.warehouse_units.units[norm.customUnitId].storage_amount
      //     }
      //   })
      // }

      console.log('[AddNorm] Emitting norms:', this.norms.length, 'items')
      console.log('[AddNorm] First norm:', this.norms[0])
      that.$emit('add', { norms: this.norms, normType: this.selectedNormType })
      this.close()
    }
  }
}
</script>

<style scoped>
/* Glass Card Modal */
.glass-card-modal {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px) !important;
  border-radius: 16px !important;
  border: 1px solid rgba(0, 179, 190, 0.2) !important;
  box-shadow: 0 8px 32px rgba(0, 179, 190, 0.15) !important;
  overflow: hidden !important;
}

/* Glass Header with Gradient */
.glass-header-modal {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.5) 0%,
    rgba(57, 137, 201, 0.45) 50%,
    rgba(97, 84, 164, 0.5) 100%) !important;
  padding: 24px !important;
  position: relative;
}

.glass-header-modal::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  opacity: 0.3;
  z-index: 0;
}

.modal-title {
  font-size: 22px !important;
  font-weight: 700 !important;
  color: white !important;
  letter-spacing: 0.5px !important;
  margin: 0 !important;
  position: relative;
  z-index: 1;
}

.modal-subtitle {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: rgba(255, 255, 255, 0.9) !important;
  margin: 4px 0 0 0 !important;
  position: relative;
  z-index: 1;
}

.close-icon {
  cursor: pointer;
  transition: all 0.2s ease !important;
  position: relative;
  z-index: 1;
}

.close-icon:hover {
  transform: rotate(90deg) scale(1.1);
  opacity: 0.8;
}

/* Modal Content */
.modal-content {
  padding: 20px 16px !important;
  max-height: 500px;
  overflow-y: auto;
}

/* Filter Select Inputs */
.filter-select.v-text-field--outlined >>> fieldset {
  border-color: rgba(57, 137, 201, 0.2) !important;
  border-radius: 8px !important;
}

.filter-select.v-text-field--outlined:hover >>> fieldset {
  border-color: rgba(57, 137, 201, 0.4) !important;
}

.filter-select.v-text-field--outlined.v-input--is-focused >>> fieldset {
  border-color: #3989C9 !important;
  border-width: 2px !important;
}

.filter-select >>> .v-input__slot {
  background: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: blur(10px) !important;
  min-height: 40px !important;
  border-radius: 8px !important;
}

.filter-select >>> .v-select__selection,
.filter-select >>> .v-text-field__slot input {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: rgba(70, 70, 80, 0.9) !important;
}

.filter-select >>> label {
  font-size: 12px !important;
  font-weight: 500 !important;
  color: rgba(57, 137, 201, 0.8) !important;
}

/* Add Norm Button */
.add-norm-btn {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.95) 0%,
    rgba(57, 137, 201, 0.9) 50%,
    rgba(97, 84, 164, 0.95) 100%) !important;
  color: white !important;
  border-radius: 8px !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  box-shadow: 0 2px 8px rgba(0, 179, 190, 0.25) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  letter-spacing: 0.3px !important;
  height: 40px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.add-norm-btn:hover {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 1) 0%,
    rgba(57, 137, 201, 0.95) 50%,
    rgba(97, 84, 164, 1) 100%) !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 179, 190, 0.35) !important;
}

.add-norm-btn .v-icon {
  color: white !important;
}

/* Norms List */
.norms-list-header {
  padding: 12px 0;
  border-bottom: 2px solid rgba(0, 179, 190, 0.2);
}

.list-title {
  font-size: 16px !important;
  font-weight: 600 !important;
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 1) 0%,
    rgba(57, 137, 201, 1) 50%,
    rgba(97, 84, 164, 1) 100%) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  background-clip: text !important;
  letter-spacing: 0.5px !important;
  display: inline-block !important;
  margin: 0 !important;
}

.norms-list {
  padding-top: 8px;
}

/* Norm Item Card */
.norm-item-card {
  background: rgba(255, 255, 255, 0.6) !important;
  backdrop-filter: blur(10px) !important;
  border-radius: 12px !important;
  border: 1px solid rgba(0, 179, 190, 0.15) !important;
  padding: 12px !important;
  transition: all 0.2s ease !important;
}

.norm-item-card:hover {
  background: rgba(255, 255, 255, 0.8) !important;
  border-color: rgba(0, 179, 190, 0.3) !important;
  box-shadow: 0 2px 8px rgba(0, 179, 190, 0.1) !important;
}

/* Remove Norm Button */
.remove-norm-btn {
  background: rgba(244, 67, 54, 0.1) !important;
  color: #F44336 !important;
  transition: all 0.2s ease !important;
}

.remove-norm-btn:hover {
  background: rgba(244, 67, 54, 0.2) !important;
  transform: scale(1.1);
}

.remove-norm-btn .v-icon {
  color: #F44336 !important;
}

/* Modal Actions */
.modal-actions {
  padding: 16px 24px !important;
  background: rgba(250, 250, 252, 0.8) !important;
  border-top: 1px solid rgba(0, 179, 190, 0.15) !important;
  justify-content: center !important;
}

/* Save Button */
.save-btn {
  background: linear-gradient(135deg,
    rgba(76, 175, 80, 0.95) 0%,
    rgba(56, 142, 60, 0.9) 100%) !important;
  color: white !important;
  border-radius: 12px !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  padding: 12px 32px !important;
  height: 48px !important;
  min-width: 200px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.save-btn:hover {
  background: linear-gradient(135deg,
    rgba(76, 175, 80, 1) 0%,
    rgba(56, 142, 60, 1) 100%) !important;
  transform: translateY(-2px) scale(1.02);
  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.4) !important;
}

.save-btn .v-icon {
  color: white !important;
}

/* Scrollbar Styling */
.modal-content::-webkit-scrollbar {
  width: 8px;
}

.modal-content::-webkit-scrollbar-track {
  background: rgba(0, 179, 190, 0.05);
  border-radius: 4px;
}

.modal-content::-webkit-scrollbar-thumb {
  background: rgba(0, 179, 190, 0.3);
  border-radius: 4px;
}

.modal-content::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 179, 190, 0.5);
}
</style>
